/**
 * DEV impersonation helper (Sprint A1).
 *
 * Зберігає «знімок» реального адміна перед входом під іншою особою/роллю,
 * щоб банер міг повернути назад одним кліком (аналог Jinja `/dev/back`).
 *
 * ТІЛЬКИ dev-інструмент. Бек-ендпоінт /api/v1/dev/impersonate віддає 403 у
 * production, тож у проді цей потік недосяжний навіть якщо в localStorage
 * лишиться ключ.
 */
import type { LoginUser, TokenPair } from "@/types/api";

const KEY = "mes-dev-admin";

export interface AdminSnapshot {
  tokens: TokenPair;
  user: LoginUser;
}

/** Зберегти знімок адміна (лише перший раз — щоб не перезаписати оригінал
 *  при ланцюжку перемикань роль→роль). */
export function saveAdminSnapshot(s: AdminSnapshot): void {
  if (localStorage.getItem(KEY)) return;
  localStorage.setItem(KEY, JSON.stringify(s));
}

export function getAdminSnapshot(): AdminSnapshot | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as AdminSnapshot) : null;
  } catch {
    return null;
  }
}

export function clearAdminSnapshot(): void {
  localStorage.removeItem(KEY);
}
